import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import Logo from '../assets/img/logo.png';
import LanguageToggle from './LanguageToggle';
import { HashLink } from 'react-router-hash-link';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const onHome = location.pathname === '/';

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10); // غيّر العتبة لو حابب
    onScroll(); // علشان يشتغل أول ما الصفحة تفتح
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navClasses = [
    'navbar',
    'navbar-expand-md',
    'bg-inverse',
    'fixed-top',
    'scrolling-navbar',
    (scrolled || !onHome) ? 'navbar-solid' : ''
  ].join(' ').trim();

  return (
    <header id="header-wrap">
      <nav className={navClasses}>
        <div className="container">
          <a href="/">
            <img src={Logo} alt="Al-Buffia logo" style={{ height: '40px' }} />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="lni-menu"></i>
          </button>

          {onHome && (
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav ms-auto w-100 justify-content-end clearfix">
                <li className="nav-item">
                  <HashLink className="nav-link no-hover" smooth to="/#hero-area">Home</HashLink>
                </li>
                <li className="nav-item">
                  <HashLink className="nav-link no-hover" smooth to="/#services">Services</HashLink>
                </li>
                <li className="nav-item">
                  <HashLink className="nav-link no-hover" smooth to="/#how-it-works">How it Works</HashLink>
                </li>
                <li className="nav-item">
                  <HashLink className="nav-link no-hover" smooth to="/#features">Features</HashLink>
                </li>
              </ul>
              <div className="d-flex align-items-center ms-3">
                <a href="/login" className="btn btn-common btn-sm me-2 no-hover">Login</a>
                <a href="/register" className="btn btn-common btn-sm me-2 no-hover">Register</a>
              </div>
            </div>
          )}

          {/* <LanguageToggle /> */}
        </div>
      </nav>
    </header>
  );
};
export default Header;
